import { Component, ChangeDetectionStrategy, ViewEncapsulation, Input } from '@angular/core';

@Component({
    selector: 'tr-player-progress-indicator',
    template: `<span [hidden]="!current || !total" class='tr-player-progress-indicator font-light-color font-small--regular'>
        {{current}} / {{total}}
    </span>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class TrPlayerProgressIndicator {
    @Input() public current: string;
    @Input() public total: string;
}
